import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { Wrapper, Tag, TooltipItem, TooltipTitle } from './styled'

interface IProps {
  items: string[]
}

const Prerequisites = ({ items }: IProps) => {
  return (
    <>
      {items.length ? (
        <Wrapper>
          <Tooltip
            title={
              <TooltipItem>
                <FontAwesomeIcon icon={faCircle} />
                <TooltipTitle>{items[0]}</TooltipTitle>
              </TooltipItem>
            }
            placement="top"
          >
            <Tag istotal="false">{items[0]}</Tag>
          </Tooltip>
          {items.length > 1 && (
            <Tooltip
              title={items.slice(1).map((item, index) => (
                <TooltipItem key={index}>
                  <FontAwesomeIcon icon={faCircle} />
                  <TooltipTitle>{item}</TooltipTitle>
                </TooltipItem>
              ))}
              placement="top"
            >
              <Tag istotal="true">+{items.length - 1}</Tag>
            </Tooltip>
          )}
        </Wrapper>
      ) : (
        '--'
      )}
    </>
  )
}

export default Prerequisites
